import { RoomType } from 'pages/common/types';
import {
  facetsIds,
  classFacetValues,
  thicknessFacetValues,
  waterResistanceFacetValues,
} from '../../../const';

export const getFacetsValues = (facetId: string, roomType: RoomType): Array<string> => {
  switch (facetId) {
    case facetsIds.THICKNESS:
      return thicknessFacetValues[roomType];
    case facetsIds.CLASS:
      return classFacetValues[roomType];
    case facetsIds.WATER_RESISTANCE:
      return waterResistanceFacetValues[roomType];
    default:
      return [''];
  }
};
